module.exports = __webpack_public_path__ + "static/media/GvGIcon.8743247a.png";